import {
    apiRequest,
    pensiunskList,
    pensiunskActive,
    pensiunskInactive
} from "../../../../../services/adapters/kepegawaian/pensiunskService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", pensiunskList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", pensiunskInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", pensiunskActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository